import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import nhsLogo from "@/assets/nhs-logo.png";
const footerLinks = {
  services: [{
    name: "The Inventory",
    href: "/inventory"
  }, {
    name: "Services & Pricing",
    href: "/services"
  }],
  about: [{
    name: "About",
    href: "/about"
  }, {
    name: "Contact",
    href: "/contact"
  }],
  legal: [{
    name: "Privacy Policy",
    href: "/legal#privacy"
  }, {
    name: "Terms of Service",
    href: "/legal#terms"
  }, {
    name: "Cookie Policy",
    href: "/legal#cookies"
  }]
};
export const Footer = () => {
  return <footer className="bg-secondary/50 border-t border-border">
      <div className="container-wide section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center mb-4">
              <span className="font-display font-semibold text-lg text-foreground">
                The Partnership Lab
              </span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed mb-4">
              Evidence-informed leadership consultancy supporting NHS practices. 
              Better governance. Better performance. Better lives.
            </p>
            <div className="flex items-center gap-2 text-sm text-primary">
              <Heart className="h-4 w-4" />
              <span>Profits donated to charity</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-sm link-subtle">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">About</h4>
            <ul className="space-y-3">
              {footerLinks.about.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-sm link-subtle">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Legal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-sm link-subtle">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-border flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} The Partnership Lab. All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            <p className="text-sm text-muted-foreground">Designed for NHS General Practice Organisations</p>
            <img src={nhsLogo} alt="NHS" className="h-6" />
          </div>
        </div>
      </div>
    </footer>;
};